module.exports = __webpack_public_path__ + "img/01LeeStreetLofts.93230364.jpg";